"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTable = void 0;
var CustomTable_1 = require("./CustomTable");
Object.defineProperty(exports, "CustomTable", { enumerable: true, get: function () { return __importDefault(CustomTable_1).default; } });
